import { useMemo, useState } from "react";
import { Loader,Linkedin,CircleChevronDown } from "lucide-react";

export function useJobInsightFilters() {
  const [selectedFilter, setSelectedFilter] = useState<string | null>(null);
  const [search, setSearch] = useState("");

  const filters = useMemo(() => {
    return [
      {
        key: "candidateJobFit",
        icon: Loader,
        label: "Candidate Job Fit",
        options: null,
      },
      {
        key: "experienceLevel",
        icon: Loader,
        label: "Experience Level",
        options: null,
      },
      {
        key: "source",
        icon: Loader,
        label: "Source",
        options: [
          { name: "HirePanda", icon: CircleChevronDown },
          { name: "LinkedIn", icon: Linkedin },
          { name: "Referral", icon: CircleChevronDown },
          { name: "Indeed", icon: CircleChevronDown },
        ]?.map(({ name, icon }) => ({
          value: name.toLowerCase(),
          label: name,
          icon,
          right: null,
          hideDuringSearch: false,
        })) ?? null,
      },
    ];
  }, []);

  const activeFilters = useMemo(() => {
    return [];
  }, []);

  const onSelect = (key: string, value: any) => {
    console.log("select", key, value);
  };

  const onRemove = (key: string, value: any) => {
    console.log("remove", key, value);
  };

  const onRemoveAll = () => {
    console.log("remove all");
  };

  return {
    filters,
    activeFilters,
    onSelect,
    onRemove,
    onRemoveAll,
    setSearch,
    setSelectedFilter,
  };
}
